import React, { useState, useEffect, useCallback } from 'react';
import { DataGridPro, useGridApiContext, GridCellEditStopReasons, GridRowModel, } from '@mui/x-data-grid-pro';
import { Auth } from 'aws-amplify';
import { getInvoiceHistoryList, deleteHistory } from '../CbpInvoiceList/services/cbpInvoiceListApi'
import { CBP_INVOICE_HISTORY_URL, CBP_INVOICE_DELETE_HISTORY_URL, dateFormat, formDateFormat } from '../../../constants';
// import { TypographyLink } from '../../ui/styled';
import { paginationSize, CBP_INVOICE_UPDATE_URL } from '../../../constants';
import { useDispatch, useSelector } from 'react-redux';
import CommonSearch from '../../common/Search/CommonSearch';
//import { renderCellExpand } from '../../common/GridCell/GridCellExpand';
import { getHeading } from '../../common/commonUtils/commonUtils';
import moment from 'moment';
import Typography from '@mui/material/Typography';
import { commonQueryParams } from '../../../services/QueryParams/QueryParams';
import { setStopApi } from '../../../services/StopApi/StopApi';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';

const InvoiceHistoryList = () => {
  const dispatch = useDispatch();
  const [user, setUser] = useState(null);
  const [visibleInvIds, setVisibleInvIds] = React.useState('');
  const [searchInvoiceHistoryList, setSearchInvoiceHistoryList] =
    useState('');
  const [
    openInvoiceHistoryDetailDialog,
    setOpenInvoiceHistoryDetailDialog,
  ] = useState(false);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [invoiceHistoryListData, setInvoiceHistoryListData] =
    useState({
      isLoading: false,
      data: [],
      pageSize: 250,
      total: 0,
      page: 1,
      sortModel: '',
      filterModel: {}
    });

  useEffect(() => {
    if (user?.signInUserSession.accessToken.jwtToken) {
      fetchData();
    }
    getUser().then((userData) => setUser(userData));
  }, [
    user?.signInUserSession.accessToken.jwtToken,
    invoiceHistoryListData.page,
    invoiceHistoryListData.pageSize,
    invoiceHistoryListData.sortModel,
    invoiceHistoryListData.filterModel,
    searchInvoiceHistoryList,
  ]);

  const getUser = () => {
    return Auth.currentAuthenticatedUser()
      .then((userData) => userData)
      .catch(() => console.log('Not signed in'));
  };

  const QuickSearchToolbar = () => {
    return (
      <CommonSearch
        searchText={searchInvoiceHistoryList}
        setSearchText={setSearchInvoiceHistoryList}
      />
    );
  };

  const fetchData = async () => {
    setInvoiceHistoryListData((prveState) => ({ ...prveState, isLoading: true }));
    const commonParams = commonQueryParams(
      CBP_INVOICE_HISTORY_URL,
      searchInvoiceHistoryList,
      invoiceHistoryListData
    );
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    const cbpInvoiceHistoryList = await getInvoiceHistoryList({
      commonParams,
      authorization,
    });
    //console.log('###cbpInvoiceHistoryList');
    //console.log(cbpInvoiceHistoryList);
    let IDs = '';
    cbpInvoiceHistoryList.data.forEach(function (item) {
      IDs += (item.cboInvID + ','); 
    });
    setVisibleInvIds(IDs.slice(0, -1));

    setInvoiceHistoryListData((prveState) => ({
     ...prveState,
     ...cbpInvoiceHistoryList,
    }));
  };

  const handleProcessRowUpdate = useCallback((row) => {
    console.log(row);
    
    var formats = ['MM/DD/YYYY', 'MM/DD/YY', moment.ISO_8601];

    const cboInvVerDateBack = moment(row.cboInvVerDateBack, formats);
    row.cboInvVerDateBack = cboInvVerDateBack.isValid() ? cboInvVerDateBack : null;

    const cboInvCorVerDateFax = moment(row.cboInvCorVerDateFax, formats);
    row.cboInvCorVerDateFax = cboInvCorVerDateFax.isValid() ? cboInvCorVerDateFax : null;

    const cboInvCorVerDateBack = moment(row.cboInvCorVerDateBack, formats);
    row.cboInvCorVerDateBack = cboInvCorVerDateBack.isValid() ? cboInvCorVerDateBack : null;

    const url = `${CBP_INVOICE_UPDATE_URL}/cor/${row.cboInvCorID}`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    const payload = row

    setStopApi({ url, payload, authorization }).then((response) => {
      if (response.succeeded === true) {        
        fetchData();
      }
    }).catch((e) => alert(e));
    return row;
  });

  const handleProcessRowUpdateError = useCallback((error) => {
    console.log(error);
  });

  const handleSortModelChange = useCallback((sortModel) => {
    setInvoiceHistoryListData((old) => ({
      ...old,
      sortModel: [...sortModel],
    }));
  }, []);

  const handleFilterChange = useCallback((filterModel) => {
    // Here you save the data you need from the filter model
    //console.log(filterModel);
    setInvoiceHistoryListData((old) => ({ ...old, filterModel: {...filterModel} }));
  }, []);
  
  const handleRemoveHistory = () => {
    const url = `${CBP_INVOICE_DELETE_HISTORY_URL}${visibleInvIds}`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    deleteHistory({ url, authorization }).then((response) => {
      fetchData();
    });
  }

  //   const updateCBpInvoiceList = (params) => {
  //     const { row } = params;
  //     const cbpInvoiceDetail = {
  //       CbpInvID: row.CbpInvID,
  //       DateFaxed: row.DateFaxedWithOutFormate,
  //       DateRecived: row.DateRecivedWithOutFormate,
  //       Signed: row.Signed,
  //     };
  //     dispatch(getCbpInvoiceDetail(cbpInvoiceDetail));
  //     setOpenBackdrop(true);
  //     setTimeout(() => {
  //       setOpenBackdrop(false);
  //     }, 1000);
  //     setOpenTransportationInvoiceDetailDialog(true);
  //   };

  function SelectEditInputCell(props) {
    const { id, value, field } = props;
    const apiRef = useGridApiContext();

    const handleChange = async (event: SelectChangeEvent) => {
      await apiRef.current.setEditCellValue({ id, field, value: event.target.value });
      apiRef.current.stopCellEditMode({ id, field });
    };

    return (
      <Select
        value={value}
        onChange={handleChange}
        size="small"
        sx={{ height: 1 }}
        //native
        //autoFocus
      >
        <MenuItem value={null}>--Clear Entry--</MenuItem>
        <MenuItem value={1}>CBP Added Current Tx</MenuItem>
        <MenuItem value={2}>CBP Added Out of Mth Tx</MenuItem>
        <MenuItem value={3}>Data Entry Missed Tx</MenuItem>
        <MenuItem value={4}>Data Entry Missed Auth or Discharge</MenuItem>
        <MenuItem value={5}>CBP Missing Vers</MenuItem>
        <MenuItem value={6}>CBP Deleted Tx</MenuItem>
        <MenuItem value={7}>Auth Not Received</MenuItem>
      </Select>
    );
  }

  const renderSelectEditInputCell: GridColDef['renderCell'] = (params) => {
    return <SelectEditInputCell {...params} />;
  };



  const columnsData = [
    {
      field: 'cboInvID',
      headerName: 'CbpInvID',
    },
    {
      field: 'cboName',
      headerName: 'CBP (Provider)',
      minWidth: 300,
    },
    { field: 'cboID', headerName: 'CbpID', minWidth: 80, },
    { field: 'cboInv_MthID', headerName: 'Month', minWidth: 80, },
    { field: 'cboInvDateCreate', headerName: 'Created', minWidth: 100, 
      renderCell: (params) => {
        return (
          <Typography>{params.value ? moment(params.value).format(dateFormat) : ''}</Typography>
          );
      },  
    },
    {
      field: 'cboInvDateSent',
      headerName: 'Date Locked',
      type: 'date',
      minWidth: 100,
      renderCell: (params) => {
        return (
          <Typography>{params.value ? moment(params.value).format(dateFormat) : ''}</Typography>
          );
      },
    },
    {
      field: 'cboInvVerDateFax',
      headerName: 'Faxed',
      minWidth: 100,
      renderCell: (params) => {
        return (
          <Typography>{params.value ? moment(params.value).format(dateFormat) : ''}</Typography>
          );
      },

    },
    { field: 'cboInvVerDateBack', headerName: 'Received', minWidth: 100, editable: true,       
      renderCell: (params) => {
        return (
          <Typography>{params.value ? moment(params.value).format(dateFormat) : ''}</Typography>
          );
        },
    },
    { field: 'cboInvVerSignYN', headerName: 'Signed', minWidth: 100, editable: true, type: 'boolean'},
    { field: 'cboInvTmtAmt', headerName: 'Original Amount', minWidth: 100, },
    { field: 'cboInvCorVerDateFax', headerName: 'Corrected Faxed', minWidth: 100, editable: true,
      renderCell: (params) => {
        return (
          <Typography>{params.value ? moment(params.value).format(dateFormat) : ''}</Typography>
          );
      },

    },
    { field: 'cboInvCorVerDateBack', headerName: 'Corrected Received', minWidth: 100, editable: true,
      renderCell: (params) => {
        return (
          <Typography>{params.value ? moment(params.value).format(dateFormat) : ''}</Typography>
          );
      },
    },
    { field: 'cboInvCorVerSignYN', headerName: 'Cor Signed', minWidth: 100, editable: true, type: 'boolean'},
    { field: 'cboInvCorAmt', headerName: 'Adjusted Amount', minWidth: 100, editable: true,},
    { field: 'cboInvCorRsn', headerName: 'Adjustment Reason', minWidth: 190, editable: true, renderEditCell: renderSelectEditInputCell,
      renderCell: (params) => {
        return (
          <Typography>{!params.value ? '' : 
          params.value==1 ? 'CBP Added Current Tx' : 
          params.value==2 ? 'CBP Added Out of Mth Tx' : 
          params.value==3 ? 'Data Entry Missed Tx' : 
          params.value==4 ? 'Data Entry Missed Auth or Discharge' : 
          params.value==5 ? 'CBP Missing Vers' : 
          params.value==6 ? 'CBP Deleted Tx' : 
          'Auth Not Received'}</Typography>
          );
      },
    },  
    { field: 'cboInvRevDsc', headerName: 'Note', minWidth: 300, editable: true,},
  ];

  return (
    <>
      {getHeading('CBP Invoice History List')}
      <DataGridPro
        filterMode="server"
        onFilterModelChange={handleFilterChange}
        autoHeight
        getRowId={(row) => row.cboInvCorID}
        getRowHeight={() => 'auto'}
        columns={columnsData}
        rows={invoiceHistoryListData.data}
        pageSize={invoiceHistoryListData.pageSize}
        page={invoiceHistoryListData.page - 1}
        rowCount={invoiceHistoryListData.total}
        paginationMode='server'
        sortingMode='server'
        onPageSizeChange={(newPageSize) =>
          setInvoiceHistoryListData((prveState) => ({
            ...prveState,
            pageSize: newPageSize,
          }))
        }
        onPageChange={(newPage) => {
          setInvoiceHistoryListData((prveState) => ({
            ...prveState,
            page: newPage + 1,
          }));
        }}
        rowsPerPageOptions={paginationSize}
        pagination
        components={{ Toolbar: QuickSearchToolbar }}
        experimentalFeatures={{ newEditingApi: true }}
        onSortModelChange={handleSortModelChange}
        getRowClassName={(params) =>
          params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
        }
        loading={invoiceHistoryListData.isLoading}
        processRowUpdate={handleProcessRowUpdate}
        onCellEditStop={(params, event) => {
          if (params.reason === GridCellEditStopReasons.cellFocusOut) {
            event.defaultMuiPrevented = true;
          }
        }}
        onProcessRowUpdateError={handleProcessRowUpdateError}
      />
      {/* <CbpInvoiceListDialog
        open={openTransportationInvoiceDetailDialog}
        setOpen={setOpenTransportationInvoiceDetailDialog}
        authToken={user?.signInUserSession.accessToken.jwtToken}
        openBackdrop={openBackdrop}
        fetchData={fetchData}
      /> */}

      <Grid container spacing={2} style={{ marginTop: '0px' }}>
        <Grid item xs={12} sm={3.2}>
          <Button
            variant='contained'
            onClick={() => handleRemoveHistory()}
          >
            Remove Visible Invoices From History List
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default InvoiceHistoryList;
